import BaseModel, {defineTranslatableProperties} from "../../../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class AuctionCategoryTermModel extends BaseModel {
  uuid = null;
  category_uuid = null;
  auction_uuid = null;
  commissions = [];
  premiums = [];
  minimum_commission = null;
  minimum_premium = null;
  tax_rate = null;

  static TRANSLATABLE_FIELDS = [];

  attributeHints = {}

  rules = {
    minimum_premium: 'required',
    minimum_commission: 'required',
    category_uuid: 'required',
    tax_rate: 'max_value:100|min_value:0'
  };

  attributeLabels = {
    category_uuid: i18n.t('Category'),
    minimum_premium: i18n.t('Minimum Premium'),
    minimum_commission: i18n.t('Commission Premium'),
    tax_rate: i18n.t('Tax Rate'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }


  toJSON() {
    let data = super.toJSON();
    return data;
  }
}

defineTranslatableProperties(AuctionCategoryTermModel);
